<style lang="less" scoped>
    .container {
        .list-container {
            height: 100%;
            .ivu-col {
                height: 100%;
                overflow: auto;
            }
        }
        /deep/ .ivu-tree-title{
            width: 100%;
        }
        /deep/ .type-row{
            font-size: 12px;
            .type-name{
                display: inline-block;
                height: 24px;
                line-height: 24px;
                padding-left: 5px;
            }
            .text-name-text{
                display: inline-block;
                vertical-align: top;
            }
            &:hover {
                background-color: #e5e5e5;
            }
        }
        /deep/ .type-hl{
            &:hover {
                color: #2D8cF0;
            }
        }
        /deep/ .ivu-tree ul li{
            margin: 2px 0;
        }
        /deep/ .ivu-btn-small{
            font-size: 12px;
        }
    }
</style>
<template>
  <div class="container">
    <Row>
      <i-col span="14">
        <Tree
          :data="tree_data"
          :render="childRender"
        />
      </i-col>
    </Row>

    <Modal
      v-model="edit_config.modal"
      width="600"
      title="添加 / 修改"
      ok-text="保存"
      :loading="edit_config.loading"
      @on-ok="editOK"
    >
      <Form
        ref="typeForm"
        :model="edit_type"
        :label-width="80"
      >
        <Form-item
          label="父团队"
          prop="parent_id"
        >
          <Select
            v-model="edit_type.parent_id"
            placeholder="选择父级"
          >
            <Option :value="0">
              无
            </Option>
            <Option
              v-for="type in select_types"
              v-if="!type.del"
              :key="type.id"
              :value="type.id"
            >
              {{ type.name }}
            </Option>
          </Select>
        </Form-item>
        <Form-item
          label="类目级别"
          prop="level"
        >
          <Select
            v-model="edit_type.level"
            :disabled="!!edit_type.parent_id"
            placeholder="选择级别"
          >
            <Option :value="1">
              1级
            </Option>
            <Option :value="2">
              2级
            </Option>
            <Option :value="3">
              3级
            </Option>
            <Option :value="4">
              4级
            </Option>
            <Option :value="5">
              5级
            </Option>
          </Select>
        </Form-item>
        <Form-item
          label="类目名称"
          prop="name"
        >
          <i-input
            v-model="edit_type.name"
            placeholder="请输入"
          />
        </Form-item>
        <Form-item
          label="产品分类"
          prop="group"
        >
          <Select
            clearable
            v-model="edit_type.group"
            placeholder="品类"
          >
            <Option
              v-for="group in groups"
              :key="group.code"
              :disabled="group.property==='Service'"
              :value="group.code"
            >
              {{ group.name }}
            </Option>
          </Select>
        </Form-item>
        <Form-item

            prop="tax_code_id"
            label="税收编码"
          
          >
            <Select
              clearable
              v-model="edit_type.tax_code_id"
            >
              <Option
                v-for="tax_code in tax_codes"
                :key="tax_code.id"
                :value="tax_code.id"
              >
                {{ tax_code.name }}-{{ tax_code.code }}
              </Option>
            </Select>
          </Form-item>
      </Form>
    </Modal>
  </div>
</template>
<script route="/stock/product_type">
  import StockUtil from './libs/util';
  import {getTaxCodeApi} from './service'
  export default {
    /* router_info_start */
    router_info: '/stock/product_type',
    /* router_info_end */

    data() {
      this.groups = StockUtil.groups
    
      return {
        tax_codes: [],
        tree_types: [],
        types: [],
        types_hash: {},
        level_types_hash: {},
        edit_type: {},
        edit_config: {
          modal: false,
          loading: true
        },
        button_props: {
          type: 'default',
          size: 'small',
        },
      }
    },
    computed: {
      tree_data() {
        return [{
          id: 0,
          name: '电商类目',
          expand: true,
          children: this.tree_types,
          render: (h, { root, node, data }) => {
            return h('span', {
              style: {
                display: 'inline-block',
                width: '100%',
                //cursor: 'pointer'
              },
              class: {
                'type-row': true,
              },
            }, [
              h('span', [
                h('span', data.name)
              ]),
              h('span', {
                style: {
                  display: 'inline-block',
                  float: 'right',
                  marginRight: '32px'
                }
              }, [
                h('Button', {
                  props: Object.assign({}, this.button_props, {
                    icon: 'ios-add',
                    type: 'primary'
                  }),
                  style: {
                    width: '88px'
                  },
                  on: {
                    click: () => { this.addType(StockUtil.new_product_type) }
                  }
                }, '添加类目')
              ])
            ]);
          }
        }]
      },
      select_types() {
        const edit_level = this.edit_type.level;
        const select_level = edit_level - 1;
        const types = this.level_types_hash[select_level];
        return types ? types : [];
      },
    },
    created() {
      //
      this.getTaxCodes()
    },
    mounted() {
      this.getTreeInfo();
    },
    methods: {
      getTaxCodes() {
        getTaxCodeApi().then(res=>{
          res = res || {}
          this.tax_codes = res.items || []
          // console.log(res.data)
        })
      },
      childRender(h, { root, node, data }) {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%',
            //cursor: 'pointer'
          },
          class: {
            'type-row': true,
            'type-hl': true
          },
        }, [
          h('span', {
            class: {
              'type-name': true,
              'color-grey': data.del,
              'text-delete': data.del,
            }
          }, [
            h('span', {
              class: {
                'text-bold': !data.del,
                'text-name-text': true
              },
            }, data.name),

          ]),
          h('span', {
            style: {
              display: 'inline-block',
              float: 'right',
              marginRight: '32px'
            }
          }, [
            h('span', `${data.level}级 `),
            h('Tooltip', {
              props: {
                placement: 'top'
              }
            }, [
              h('Button', {
                props: Object.assign({}, this.button_props, {
                  icon: 'ios-create'
                }),
                style: {
                  marginRight: '8px'
                },
                on: {
                  click: () => { this.editType(data) }
                }
              }),
              h('span', {
                slot: 'content'
              }, '编辑类目')
            ]),
            h('Tooltip', {
              props: {
                placement: 'top'
              }
            }, [
              h('Button', {
                props: Object.assign({}, this.button_props, {
                  icon: 'ios-add',
                  disabled: data.del
                }),
                style: {
                  marginRight: '8px'
                },
                on: {
                  click: () => { this.addType(StockUtil.new_product_type, data) }
                }
              }),
              h('span', {
                slot: 'content'
              }, '添加子类目')
            ]),
            h('Tooltip', {
              props: {
                placement: 'top'
              }
            }, [
              h('Button', {
                props: Object.assign({}, this.button_props, {
                  icon: 'ios-close',
                  disabled: data.del
                }),
                on: {
                  click: () => { this.deleteType(data) }
                }
              }),
              h('span', {
                slot: 'content'
              }, '废弃类目')
            ]),
          ])
        ]);
      },
      getTreeInfo() {
        this.$util.ajax.get(this.$util.api.product_type_tree_info, {
          params: {}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            const data = res.data;
            this.handleTreeInfo(data.tree_info);
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          // always executed
        });
      },
      handleTreeInfo(tree_info) {
        const types = tree_info.top_types;
        this.level_types_hash = tree_info.level_types_hash;
        this.types = [];
        this.tree_types = this.handleTreeData(types);
      },
      handleTreeData(types) {
        types.forEach((type) => {
          if (type.children.length) {
            this.$set(type, 'expand', true);
          }
          this.types.push(type);
          this.types_hash[type.id] = type;
          this.handleTreeData(type.children);
        });
        return types;
      },
      addType(type, parent) {
        this.edit_type = this.$util.clone(type);
        if (parent) {
          this.edit_type.parent_id = parent.id;
          this.edit_type.level = parent.level + 1;
        }
        this.edit_config.modal = true;
      },
      editType(type) {
        this.edit_type = this.$util.clone(type);
        this.edit_config.modal = true;
      },
      deleteType() {
        //
      },
      editOK() {
        this.edit_type.name = this.edit_type.name.trim();
        let valid = true;
        if (!this.edit_type.name) {
          valid = false;
          this.$Message.error('名称不能为空');
        }
        if (!valid) {
          this.resetEditLoading();
          return;
        }
        this.edit_type.group = this.edit_type.group || null
        this.edit_type.tax_code_id = this.edit_type.tax_code_id || null
        this.$util.ajax.post(this.$util.api.update_product_type, this.edit_type).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.handleTreeInfo(data.tree_info);
            this.$Message.success('提交成功!');
            this.edit_config.modal = false;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.resetEditLoading();
        });
      },
      resetEditLoading() {
        this.edit_config.loading = false;
        setTimeout(() => {
          this.edit_config.loading = true;
        }, 1);
      },
    }
  }
</script>
